import intlTelInput from 'intl-tel-input';
import utils from 'intl-tel-input/build/js/utils';
import * as _ from 'underscore';

var input = document.querySelector("#phone"),
    errorMsg = document.querySelector("#error-msg"),
    validMsg = document.querySelector("#valid-msg");

var iti = intlTelInput(input, {
    preferredCountries: ["CH", "UK", "US", "FR", "ES", "IT", "DE"],
    initialCountry: "CH"
});
window.intlTelInputGlobals.loadUtils(utils);

var reset = function () {
    input.classList.remove("error");
    errorMsg.innerHTML = "";
    errorMsg.classList.add("hide");
    validMsg.classList.add("hide");
};

// on blur: validate
input.addEventListener('blur', function () {
    reset();
    if (input.value.trim()) {
        if (iti.isValidNumber()) {
            validMsg.classList.remove("hide");
        } else {
            input.classList.add("error");
            var errorCode = iti.getValidationError();
            if (errorCode < 0) { errorCode = 0; }
            errorMsg.innerHTML = errorMap[errorCode];
            console.log(errorCode);
            errorMsg.classList.remove("hide");
        }
    }
});

// on keyup / change flag: reset
input.addEventListener('change', reset);
input.addEventListener('keyup', reset);
